import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

export const defaultNamespace = "default";

export const resources = {
  en: {
    [defaultNamespace]: en,
  },
  es: {
    [defaultNamespace]: es,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: defaultNamespace,
    ns: [defaultNamespace],
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage", "cookie"],
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
    },
    debug: true,
  });
